import * as types from './types';

const initialState = {
  ratingsError: false,
  ratings: null,
  loadingRatings: true,
  hasRatings: false,
  reportsError: false,
  reports: null,
  loadingReports: true,
  hasReports: false,
  qualityError: false,
  quality: null,
  loadingQuality: true,
  hasQuality: false,
  branches: [],
  customersComments: []
};

function reputationReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_RATINGS:
      return {
        ...state,
        ratingsError: false,
        loadingRatings: true
      };
    case types.FETCH_RATINGS_COMPLETED:
      return {
        ...state,
        ratings: action.payload,
        branches: action.payload.availableBranches,
        customersComments: action.payload.customersComments,
        loadingRatings: false,
        hasRatings: true
      };
    case types.FETCH_RATINGS_FAILED:
      return {
        ...state,
        ratingsError: true,
        loadingRatings: false
      };
    case types.FETCH_QUALITY:
      return {
        ...state,
        qualityError: false,
        loadingQuality: true
      };
    case types.FETCH_QUALITY_COMPLETED:
      return {
        ...state,
        quality: action.payload,
        loadingQuality: false,
        hasQuality: true
      };
    case types.FETCH_QUALITY_FAILED:
      return {
        ...state,
        qualityError: true,
        loadingQuality: false
      };
    case types.FETCH_REPORTS:
      return {
        ...state,
        reportsError: false,
        loadingReports: true
      };
    case types.FETCH_REPORTS_COMPLETED:
      return {
        ...state,
        reports: action.payload,
        loadingReports: false,
        hasReports: true
      };
    case types.FETCH_REPORTS_FAILED:
      return {
        ...state,
        reportsError: true,
        loadingReports: false
      };
    default:
      return state;
  }
}

export { reputationReducer };
